(function () {
  function playVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    const attempt = () => {
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
    };
    attempt();
    if (video.readyState < 2) {
      video.addEventListener('loadeddata', attempt, { once: true });
    }
  }

  function initHeroVideos() {
    document.querySelectorAll('.chase-video-hero__media').forEach((video) => {
      playVideo(video);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              playVideo(video);
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(video);

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) playVideo(video);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideos);
  } else {
    initHeroVideos();
  }

  document.addEventListener('shopify:section:load', initHeroVideos);
})();